/**
 * 检查用户是否已登录
 */
import React, { useLayoutEffect, useState } from 'react';
import { message } from '@byte-design/ui';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';
import { globalInfoStore } from '@/models/global';
import { goToLogin } from '@/utils';

const usePrivateRoute = (fetchingUserInfo: boolean, alreadyLoggedIn: boolean) => {
  const [t] = useTranslation();
  const [loggedIn, setLoggedIn] = useState(false);

  useLayoutEffect(() => {
    if (!alreadyLoggedIn) {
      // 用户信息接口调用还没结束
      if (fetchingUserInfo) {
        return;
      }

      message.error(t('not_login_error') || 'You have not logged in');
      // 未登录跳转到登录页面，默认以当前地址为回调地址
      goToLogin();
      return;
    }

    setLoggedIn(true);
  }, [fetchingUserInfo, alreadyLoggedIn]);

  return loggedIn;
};

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const loggedIn = usePrivateRoute(globalInfoStore.loading, globalInfoStore.loggedIn);

  return <>{loggedIn ? children : null}</>;
};

export const PrivateOutlet = observer(() => {
  const loggedIn = usePrivateRoute(globalInfoStore.loading, globalInfoStore.loggedIn);

  return <>{loggedIn ? <Outlet /> : null}</>;
});

export default observer(PrivateRoute);
